import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import isEmpty from 'lodash/isEmpty';
import ProfilePic from '../../Header/profile-pic.svg';

export const NotificationItem = ({ notification, onNotificationClick }) => (
  <div
    className={
      notification.read
        ? 'row py-2 border-bottom notification-row'
        : 'row py-2 border-bottom notification-row unread'
    }
    onClick={() => onNotificationClick({ ...notification, read: true })}
  >
    <div className="col-2">
      <div
        className="notification-avatar"
        style={{
          backgroundImage: `url(${
            !isEmpty(notification.avatar_url)
              ? notification.avatar_url
              : ProfilePic
          })`,
        }}
      />
    </div>
    <div className="col">
      <span className="notification-list__subject t-14 text-gray">
        {notification.subject}
      </span>
    </div>

    <div className="col-4 notification-mobile">
      <div className="row">
        <span className="notification-list__elapsed t-14 text-gray-light">
          {getElapsedTime(notification.created_at)}
        </span>
      </div>
      <div className="row">
        <a
          className="notification-list__link"
          href={notification.link_url}
          target="_blank"
        >
          {notification.link_url ? 'View' : ''}
        </a>
      </div>
    </div>

    <div className="col-1 notification-lg">
      <a
        className="notification-list__link"
        href={notification.link_url}
        target="_blank"
      >
        {notification.link_url ? 'View' : ''}
      </a>
    </div>

    <div className="col-3 notification-lg">
      <span className="notification-list__elapsed t-14 text-gray-light">
        {getElapsedTime(notification.created_at)}
      </span>
    </div>
  </div>
);

export const getElapsedTime = creationDate => {
  const duration = moment.duration(moment().diff(moment(creationDate)));
  const days = duration.get('days');
  const hours = duration.get('hours');
  const minutes = duration.get('minutes');

  if (days) {
    return `${days} days ago`;
  }

  if (hours) {
    return `${hours} hours ago`;
  }

  if (minutes) {
    return `${minutes} mins ago`;
  }

  return 'seconds ago';
};

NotificationItem.propTypes = {
  notification: PropTypes.object,
  onNotificationClick: PropTypes.func,
};

export default NotificationItem;



// WEBPACK FOOTER //
// ./src/components/NotificationList/NotificationItem/NotificationItem.js